export default "__VITE_ASSET__aGxzwtya__"